import { ChangeEvent, useState } from 'react';
import { Column } from '@tanstack/react-table';
import { FILTER_OPTIONS_BY_COLUMN, TFilterOption } from '../UsersTable.helpers';
import { TIntroducerListItem } from '../UsersTable.types';

type TProps = {
  column: Column<TIntroducerListItem, unknown>;
  onClose: () => void;
};

export const useSelectColumnFilter = ({ column, onClose }: TProps) => {
  const initialFilterValue =
    (column.getFilterValue() as string[] | undefined) ?? [];

  const [selectedValues, setSelectedValues] = useState(initialFilterValue);

  const options: TFilterOption[] = FILTER_OPTIONS_BY_COLUMN[column.id] ?? [];

  const handleChange = ({
    target: { name },
  }: ChangeEvent<HTMLInputElement>) => {
    setSelectedValues((prev) =>
      prev.includes(name)
        ? prev.filter((value) => value !== name)
        : [...prev, name],
    );
  };

  const handleApply = () => {
    column.setFilterValue(selectedValues.length ? selectedValues : undefined);
    onClose();
  };

  const handleReset = () => {
    setSelectedValues([]);
    column.setFilterValue(undefined);
  };

  return {
    options,
    selectedValues,
    handleChange,
    handleApply,
    handleReset,
  };
};
